
import { prop, define } from "@/components/builder/utils";

import { useCraftCustom } from "../../core/hooks";
import { HighlightPreview } from "../../utils/Highlight";

import { useConditional, useLegacyConditional } from "./context";

function BinaryConditionPreview({ children }) {
  return children
}

function BinaryConditionHTML({ children, condition, partial = 'if' }) {
  const [case1, case2] = children

  return <>
    {`{{#${partial} ${condition}}}`}
    {case1 || null}
    {case2 ? <>
      {`{{else}}`}
      {case2}
    </> : null}
    {`{{/${partial}}}`}
  </>
}

function ConditionWrapper({ children }) {
  useConditional()
  useLegacyConditional()
  return <HighlightPreview>
    {children}
  </HighlightPreview>
}

export default define('conditional', BinaryConditionPreview, BinaryConditionHTML)
  .name('binary condition')
  .wrap(({ children }) => {
    const { value: state } = useCraftCustom('state')

    if (!state) {
      return children
    }

    return <ConditionWrapper>
      {children}
    </ConditionWrapper>
  })
  .state()
  .property(prop.text('Condition', 'condition').category('default').ignoreDevice(true).blockClear().own().props({ disabled: false }))
  .property(prop.text('Partial', 'partial').category('default').ignoreDevice(true).blockClear().own().props({ disabled: false }))
  .defaultProps({
    show: 'true',
    partial: 'if',
  })
  .build()
